import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"


import * as textAgendaLayoutStyles from "../../styles/landing_pages/TextAgendaLayout.module.css"

export default function TextAgendaLayout(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  // const featuresList = ChildSelector.select(
  //   content,
  //   `list`,
  //   ChildSelector.SELECTOR_TYPE.NODE,
  // )

  const note = ChildSelector.select(
    content,
    `note`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const answer = content.childNodes
    .filter(node => node.classNames.includes("answer"))
    .map(t => t.text)

  const question = content.childNodes
    .filter(node => node.classNames.includes("question"))
    .map(q => q.text)

  return (
    <div
      className={`row ${props.className} ${textAgendaLayoutStyles.wrapper}`}
    >
      <div
        className={`col-sm-12 col-md-12 col-lg-3 col-xl-3 ${textAgendaLayoutStyles.heading}`}
      >
        <h1
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
    
      </div>
      <div
        className={`col-sm-12 col-md-12 col-lg-9 col-xl-9 ${textAgendaLayoutStyles.content}`}
      >
        {/*  <ul className={`${textAgendaLayoutStyles.content}`}>
          {featuresList.childNodes.map((r, idx) => (
            <li
              key={idx}
              className={`${textAgendaLayoutStyles.contentItem}`}
              dangerouslySetInnerHTML={{ __html: r.innerHTML }}
            />
          ))}
        </ul> */}
        <div
          className={`${props.className} ${textAgendaLayoutStyles.content}`}
        >
          {question.map((q, idx) => (
            <span key={idx}>
              <h5>{q}</h5>
              <p>{answer[idx]}</p>
            </span>
          ))}
          <div className={`${textAgendaLayoutStyles.moreInfo}`}>
            <p>{note}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
